// This file is auto-generated. Do not edit manually.

import { z } from "zod";

export const roleSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  td: z.boolean().default(false),
});
